module.exports = __webpack_public_path__ + "img/kurand_ec_store_bnr1.10fbcfb3.png";